App.namespace('es6.shared.timezones', () => {
  App.es6.shared.cookie.set('time_offset', (new Date()).getTimezoneOffset());
  App.es6.shared.cookie.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
});
